import React from 'react';
import { Maximize2 } from 'lucide-react';

const VideoSection = () => {
  // Extraire l'ID de la vidéo Google Drive
  const videoId = '1qNnu9HHsr40562x8XBdFBOIi8UW9xEa_';
  const embedUrl = `https://drive.google.com/file/d/${videoId}/preview`;

  const handleFullscreen = () => {
    const iframe = document.querySelector('#video-iframe');
    if (iframe) {
      if (iframe.requestFullscreen) {
        iframe.requestFullscreen();
      } else if (iframe.webkitRequestFullscreen) {
        iframe.webkitRequestFullscreen();
      } else if (iframe.mozRequestFullScreen) {
        iframe.mozRequestFullScreen();
      } else if (iframe.msRequestFullscreen) {
        iframe.msRequestFullscreen();
      }
    }
  };

  return (
    <section id="video" className="py-24 bg-gradient-to-br from-primary to-cyan-600 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-10 right-10 w-72 h-72 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-cyan-300/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-cyan-300 font-semibold text-sm uppercase tracking-wider">
            Découvrez en Vidéo
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
            Nos Panneaux en Action
          </h2>
          <p className="text-xl text-cyan-50">
            Découvrez la qualité et l'impact visuel de nos installations publicitaires sur le terrain
          </p>
        </div>

        {/* Video container - Transparent, juste la vidéo */}
        <div className="max-w-7xl mx-auto">
          <div className="relative">
            {/* Google Drive Video Embed - Sans fond */}
            <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
              <iframe
                id="video-iframe"
                src={embedUrl}
                className="absolute top-0 left-0 w-full h-full rounded-3xl"
                style={{ background: 'transparent' }}
                allow="autoplay; fullscreen"
                allowFullScreen
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                title="Vidéo SESAM - Nos Panneaux en Action"
              ></iframe>
            </div>

            {/* Bouton Plein Écran */}
            <button
              onClick={handleFullscreen}
              className="absolute bottom-6 right-6 bg-white/90 hover:bg-white text-primary p-4 rounded-xl shadow-lg hover:shadow-xl transition-all hover:scale-110 flex items-center gap-2 font-semibold z-10"
              aria-label="Voir en plein écran"
            >
              <Maximize2 size={24} />
              <span className="hidden sm:inline">Plein écran</span>
            </button>
          </div>

          {/* Video description */}
          <div className="mt-12 grid md:grid-cols-3 gap-8 text-white">
            <div className="text-center space-y-3">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <div className="text-3xl font-bold mb-2">Haute Qualité</div>
                <p className="text-cyan-100">
                  Matériaux premium pour une durabilité maximale
                </p>
              </div>
            </div>
            <div className="text-center space-y-3">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <div className="text-3xl font-bold mb-2">Visibilité 24/7</div>
                <p className="text-cyan-100">
                  Impact constant jour et nuit pour vos campagnes
                </p>
              </div>
            </div>
            <div className="text-center space-y-3">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <div className="text-3xl font-bold mb-2">Emplacements Premium</div>
                <p className="text-cyan-100">
                  Sites stratégiques à fort trafic dans toute la ville
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
